import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconCardPortraitLarge = function IconCardPortraitLarge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 58 54"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 35.784,
    height: 53,
    x: 21.716,
    y: 0.5,
    fill: "#fff",
    stroke: "#47093A",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.736,
    height: 36.375,
    x: 8.786,
    y: 17.125,
    fill: "#F29A9A",
    stroke: "#47093A",
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.571,
    height: 22.843,
    x: 0.5,
    y: 30.657,
    fill: "#fff",
    stroke: "#47093A",
    rx: 3.5
  }));
};